// extracted by mini-css-extract-plugin
export default {"isMonitoredBadge":"_1vDLjdNKVSzVZYCuMk7zJ_"};